import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "./rendom_code";
import { deleteFileByUid } from "./deleteFileByUid";
import imageCompression from "browser-image-compression";

export const Uploader_files = async (data) => {
  const {
    file,
    tablename,
    fileuid,
    filename,
    old_file_uid,
    pageuid,
    contentuid,
    fileupdate,
    companyuid
  } = data || {};

  // ================= VALIDATION =================
  if (!fileuid?.trim()) return { success: false, error: "Missing fileUID" };
  if (!file) return { success: false, error: "Missing file" };
  if (!filename?.trim()) return { success: false, error: "Missing filename" };

  if (!(file.type.startsWith("image/") || file.type === "video/mp4")) {
    return { success: false, error: "Only image and .mp4 video files are allowed!" };
  }

  // ================= COMPRESS =================
  let uploadFile = file;

  if (file.size > 1 * 1024 * 1024 && file.type.startsWith("image/")) {
    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };

      uploadFile = await imageCompression(file, options);

      console.log(
        `Original: ${(file.size / 1024 / 1024).toFixed(2)}MB → Compressed: ${(uploadFile.size / 1024 / 1024).toFixed(2)}MB`
      );

      if (uploadFile.size > 1 * 1024 * 1024) {
        return { success: false, error: "File still over 1MB after compression!" };
      }

    } catch (err) {
      console.error("Compression error:", err);
      return { success: false, error: "Image compression failed: " + err.message };
    }
  }

  // ================= SESSION =================
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || !guid) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  try {
    const storage = getStorage();
    //const uid = Randomcode(22);

    // ✅ SAFE EXTENSION
    const ext = uploadFile.name?.split(".").pop() || "jpg";
    const filename_url = `${fileuid}.${ext}`;

    // const storageRef = ref(storage, `uploadsfiles/${filename_url}`);

    const storageRef = ref(storage, `${companyuid + "/" + filename.replaceAll(" ", "_") + "/" + filename_url}`);
    // ================= UPLOAD =================
    return await new Promise((resolve, reject) => {
      const uploadTask = uploadBytesResumable(storageRef, uploadFile);

      uploadTask.on(
        "state_changed",

        (snapshot) => {
          const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Upload progress: ${Math.round(percent)}%`);
        },

        (err) => {
          console.error("Upload failed:", err);
          return reject({ success: false, error: err.message || err.code || err });
        },

        async () => {
          try {
            const url = await getDownloadURL(uploadTask.snapshot.ref);

            console.log("✅ Upload complete:", url);

            // ================= SAVE FILE =================
            const parentDocRef = doc(
              db,
              "companies",
              companyuid,
              "files",
              fileuid
            );

            const savequery = {
              fileuid,
              companyuid,
              tablename,
              fileuid,
              filename,
              fileurl: url,
              size: uploadFile.size,
              type: uploadFile.type,
              guid,
              sessiontoken,
              date_time: new Date(),
            };

            await setDoc(parentDocRef, savequery, { merge: true });

            // ================= UPDATE OTHER TABLE =================
            if (fileupdate == true && tablename && fileuid && pageuid && companyuid && contentuid) {
              try {
                const updatefile = doc( 
                  db,
                  "companies",
                  companyuid,
                  "pages",
                  pageuid,
                  tablename,
                  contentuid
                );

                const updatefilequery = {
                  fileurl: url,
                  fileuid: fileuid,
                  update_date_time: new Date(),
                };

                await setDoc(updatefile, updatefilequery, { merge: true });

                console.log("✅ File updated successfully");

              } catch (err) {
                console.error("❌ Error updating file:", err);
              }
            }

            // ================= DELETE OLD =================
            if (
              old_file_uid &&
              old_file_uid.trim() &&
              old_file_uid !== fileuid
            ) {
              await deleteFileByUid(old_file_uid,companyuid);
            }

            return resolve({ success: true, fileurl: url });

          } catch (firestoreErr) {
            console.error("Firestore error:", firestoreErr);
            return reject({ success: false, error: firestoreErr.message });
          }
        }
      );
    });

  } catch (err) {
    console.error("Upload failed:", err);
    return { success: false, error: err.message || err.code || err };
  }
};